import React from 'react'
import { TAG_MULTIPATH_CTA } from '../../../store/analytics/analytics.actionTypes'
import { MODAL_IDS } from '../../../store/ui/ui.constants'
import { PUB_TAG } from '../../analytics/PublisherTagsService'
import { withOnlyGE } from '../../Device'
import RectangleActionButton, { COLOR_GREY_EMPTY } from '../../genericComponents/buttons/RectangleActionButton'
import { withFrenchSite } from '../../i18n/i18nSite'
import useModal from '../../ui/useModal'
import useEventCallback from '../../utils/useEventCallback'
import { useSelector } from 'react-redux'
import { selectGeoentityApplicationId, selectGeoentityRubricId } from '../../../store/geoentity/geoentity.selectors'

const SharePoiButton = ({ className }) => {
  const { displayModal } = useModal(MODAL_IDS.SHARE_POI_POPIN)

  const onButtonClick = useEventCallback(displayModal)
  const rubricId = useSelector(state => selectGeoentityRubricId(state))
  const applicationId = useSelector(state => selectGeoentityApplicationId(state))

  return (
    <RectangleActionButton
      color={COLOR_GREY_EMPTY}
      iconId={'telephonie-internet'}
      onClick={onButtonClick}
      tagData={{
        tagInfo: {
          Rubrique: rubricId,
          Application: applicationId,
          tag: PUB_TAG.PUB_MULTIPATH_GOTO_MOBILE_POI
        },
        type: TAG_MULTIPATH_CTA
      }}
      label={'Envoyer sur mon mobile'}
    />
  )
}

export default withFrenchSite(withOnlyGE(SharePoiButton))
